FAQAutoSuggestionListView = require('./autosuggestionlist')
FaqNoSearchResultsTemplate = require('../../no_search_results.html.mustache')

class  FAQV2AutoSuggestionListView extends FAQAutoSuggestionListView

  initialize: ->
    @noResultTemplate =  FaqNoSearchResultsTemplate
    FAQAutoSuggestionListView::initialize.apply(this, arguments)

  renderNoSuggestions : (keyword, status) ->
    @renderBreadCrumbs(keyword, "#{I18n.t('js.modules.faq.search_result')}'#{keyword}'")
    @toHtml({}, @noResultTemplate)

  renderSuggestions: (response) ->
    if response?.docs?.length > 0
      @renderBreadCrumbs(response.query, I18n.t('js.modules.faq.search_result_level'))
      @toHtml({searchQuery: "#{I18n.t('js.modules.faq.search_result')}'#{response.query}'", isV2: true})
      @renderSuggestionElements(response)
    else
      @renderNoSuggestions(response.query, 'success')

module.exports = FAQV2AutoSuggestionListView
